import clientConfigApi from '../../config/config';
import { globalIV, globalSalt } from '../../config/constant';
import { AesUtil } from '../../JS/AesUtil';

const getUpsellsData = (props, dataList) => {
    let adHocListData = [];

    const room = localStorage.getItem("room");
    const supportedAdHocList = ["Upsell"]

    const serverDateTime = props.serverTimeDatePayload.date ? new Date(props.serverTimeDatePayload.date.replace("Z", "")) : new Date();


    const adjustToHotelGMTOffset = (dateString, offset) => {
        const date = new Date(dateString.replace('Z', ''));
      
        // Adjust hours and minutes according to the offset
        date.setUTCHours(date.getUTCHours() + offset.hours);
        date.setUTCMinutes(date.getUTCMinutes() + offset.minutes);
      
        return date;
    }

    const checkShowAdhocEvent = (eventData) => {

        if(!eventData){
            return false;
        }

        const currentDay = props.serverTimeDatePayload.currentDay && props.serverTimeDatePayload.currentDay.toLowerCase() || "";


        if(currentDay && eventData.adhocEventWeekDay && Object.keys(eventData.adhocEventWeekDay).length > 0 && !eventData.adhocEventWeekDay[currentDay]){
            return false;
        }
    
        return true;
    }
    

    dataList.forEach((adhocEventsData) => {

        let adhocEventsList = [];

        if (adhocEventsData.adhocTriggers && adhocEventsData.adhocTriggers.length > 0) {
            adhocEventsData.adhocTriggers.forEach((triggerTypeData) => {
                let updatedAdhocEventsData = { ...adhocEventsData, type: triggerTypeData.triggerType };
                if (checkShowAdhocEvent(updatedAdhocEventsData)) {
                    adhocEventsList.push(updatedAdhocEventsData);
                }
            });
        } else {
            if (checkShowAdhocEvent(adhocEventsData)) {
                adhocEventsList.push(adhocEventsData);
            }
        }

        adhocEventsList.forEach((adHocEvent) => {

            adHocEvent.extraParams = JSON.parse(adHocEvent.extraParams);
            if ((supportedAdHocList.includes(adHocEvent.multimediaType))) {

                const adHocEventStartTime = adjustToHotelGMTOffset(adHocEvent.startDate, props.serverTimeDatePayload.gmtOffset);
                const adhocEventEndTime = adjustToHotelGMTOffset(adHocEvent.endDate, props.serverTimeDatePayload.gmtOffset);

                if (adHocEventStartTime <= serverDateTime && serverDateTime <= adhocEventEndTime) {

                    if(adHocEvent.type == "PRE_CHECK_IN" && (props.isPreCheckinProgress || (localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA"))) && (!room || room == "null")){
                        adHocListData.push(adHocEvent)

                    } else if(adHocEvent.type == "POST_PRE_CHECK_IN" && (localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA")) && (!room || room == "null")) {

                        adHocListData.push(adHocEvent)

                    } else if(adHocEvent.type == "GUEST_STAY" && room && room != "null"){
                        
                        adHocListData.push(adHocEvent)
                    } 
                }
            }
        })
    })


    return adHocListData;
}


export const fetchUpsells = async (props) => {


    if(Object.keys(props.serverTimeDatePayload).length == 0){
        return  {
            status: 200,
            data: []
        }
    }

    let aesUtil = new AesUtil(128, 1000);
    let guestDetails = {}


    if(props.guestDetails){
        guestDetails = props.guestDetails
    } else if(localStorage.getItem("Set_Current_Logged_In_Guest_Details")){
        guestDetails = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))[0];
    } else if((localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA"))) {
        let preCheckedInData = JSON.parse(aesUtil.decrypt(globalSalt, globalIV, "1234567891234567", (localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA"))));
        if(preCheckedInData.reservationNumber){
            guestDetails = preCheckedInData;
        }
    }


    const config = {
        header: { 
            sessionToken: `${localStorage.getItem("GuestJourneySessionToken")}`,
            reservationNumber: guestDetails.reservationNumber || null,
        }
    };

    const headers = {
        headers: {
            'Content-Type': 'application/json',
        }
    }

    try {
        let res = await clientConfigApi.post(`/adhocEvents/fetch`, config, headers)

        let upsells = getUpsellsData(props, res.data.payload.adhocEventList);

        return  {
            status: 200,
            data: upsells
        }
    } catch (error) {
        console.log("Adhoc fetching error")
        return error.response;
    }

}